import {
  Button,
  DialogFooterV2,
  Icons,
  Inset,
  Spinner,
  useCloseDialog,
  useSwipeableViews,
  Typography,
  Stack,
} from '@cast/design-system';

export const ProgressSlide = () => {
  const swipeableViewsCtx = useSwipeableViews();
  const closeDialog = useCloseDialog();

  return (
    <Stack data-testid="progress-slide">
      <Inset py>
        <Stack direction="row" gap={12}>
          <Spinner color="secondary" size={32} />
          <Stack gap={4}>
            <Typography variant="h6">Offboarding in progress...</Typography>
            <Typography variant="P12R" color="textSecondary">
              Closing this dialog will not affect the process.
            </Typography>
          </Stack>
        </Stack>
      </Inset>

      <DialogFooterV2
        divider
        startContent={
          <Button
            variant="ghost"
            startIcon={<Icons.ArrowLeft />}
            onClick={() => swipeableViewsCtx?.goToPreviousSlide()}
          >
            Back
          </Button>
        }
        endContent={
          <Button testId="close-button" variant="primary" onClick={closeDialog}>
            Close
          </Button>
        }
      />
    </Stack>
  );
};
